export default "__VITE_ASSET__BQ_0rsVq__"